import { Link } from 'react-router-dom'
import { api, useApi } from '../api/queries'
import type { components } from '../api/schema'
import { DataState } from '../components/DataState'

type Page = components['schemas']['Page_SeasonSummary_']

/**
 * Every season in one table, newest first.
 *
 * A dash where there is no champion: 2026 is still being raced, and the
 * constructors' title only began in 1958.
 */
export function SeasonsPage() {
  const seasons = useApi<Page>(['seasons'], () =>
    api.GET('/api/v1/seasons', { params: { query: { limit: 200 } } }),
  )

  return (
    <section>
      <h1>Seasons</h1>
      <DataState query={seasons} empty="No seasons have been ingested yet.">
        {(page) => (
          <div className="table-scroll">
            <table className="grid">
              <thead>
                <tr>
                  <th scope="col">Year</th>
                  <th scope="col">Drivers’ champion</th>
                  <th scope="col">Constructors’ champion</th>
                  <th scope="col" className="num">
                    Drivers
                  </th>
                  <th scope="col" className="num">
                    Races
                  </th>
                </tr>
              </thead>
              <tbody>
                {page.items.map((season) => (
                  <tr key={season.year}>
                    <td>
                      <Link to={`/seasons/${season.year}`}>
                        <strong>{season.year}</strong>
                      </Link>
                    </td>
                    {season.is_complete ? (
                      <>
                        <td>
                          {season.drivers_champion ? (
                            <Link to={`/drivers/${season.drivers_champion.slug}`}>
                              {season.drivers_champion.name}
                            </Link>
                          ) : (
                            <span className="muted">—</span>
                          )}
                        </td>
                        <td>
                          {season.constructors_champion ? (
                            <Link to={`/constructors/${season.constructors_champion.slug}`}>
                              {season.constructors_champion.name}
                            </Link>
                          ) : (
                            <span className="muted">—</span>
                          )}
                        </td>
                      </>
                    ) : (
                      <td colSpan={2} className="muted">
                        In progress · {season.rounds_with_results} of {season.total_rounds}{' '}
                        rounds
                      </td>
                    )}
                    <td className="num">{season.drivers_count}</td>
                    <td className="num">{season.total_rounds}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </DataState>
    </section>
  )
}
